import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { PrerequisiteTreeModule } from '../prerequisite-tree';
import { RelationshipsPropertiesComponent } from './relationships-properties.component';

const WIDGETS: Type<any>[] = [
	AlertComponentModule,
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	ListBuilderComponentModule,
	ObjectListModule,
	PrerequisiteTreeModule,
	TextComponentModule,
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	InheritPipe,
	IsRequiredPropertyPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [RelationshipsPropertiesComponent],
	exports: [RelationshipsPropertiesComponent]
})
export class RelationshipsPropertiesComponentModule {

}
